import { Row, Col, Form, FloatingLabel } from "react-bootstrap";

import { info, about } from "../Data";

const About = () => {
	return (
		<Row>
			<Col sm={5} lg={4}>
				{info.map((i) => (
					<FloatingLabel key={i.label} label={i.label}>
						<Form.Control
							type={i.type}
							value={i.value}
							style={{ fontWeight: "bold" }}
							className="mb-3"
							readOnly
						/>
					</FloatingLabel>
				))}
			</Col>
			<Col sm={7} lg={8}>
				<FloatingLabel label="About">
					<Form.Control
						as="textarea"
						value={about}
						style={{
							fontWeight: "bold",
							minHeight: "72vh",
							resize: "none",
						}}
						className="mb-3"
						readOnly
					/>
				</FloatingLabel>
			</Col>
		</Row>
	);
};

export default About;
